import React, { memo, useEffect, useRef } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import { FixedSizeList as List } from 'react-window';
import { useSelector } from 'react-redux';
import { partnerListIsOpenSelector } from '../../../store/modules/ui/selectors';
import { usePartnersData } from '../../../store/modules/services/searchPartnersApi/hooks';
import PartnerCard from '../PartnerCard';
import { focussedPartnerIdSelector } from '../../../store/modules/fhw/selectors';

type PartnerListDrawerProps = {
	height: number;
	width: number;
};

const Row = ({ index, style, data }: { index: number; style: any; data: any }) => {
	const classes = useStyles();
	if (!data.partners || !data.partners[index]?.id)
		return (
			<div style={style} className={classes.errorMessageSpan}>
				<Typography>{data.errorMessage ?? ''}</Typography>
			</div>
		);
	return (
		<div style={style} key={data.partners[index].id}>
			<PartnerCard partner={data.partners[index]} />
		</div>
	);
};

const PartnerList: React.FC<PartnerListDrawerProps> = ({ height, width }) => {
	const isPartnerListDrawerVisible = useSelector(partnerListIsOpenSelector);
	const focussedPartnerId = useSelector(focussedPartnerIdSelector);

	const data = usePartnersData();
	const listRef = useRef<any>();
	const classes = useStyles();

	useEffect(() => {
		if (listRef.current && listRef.current.state.scrollOffset !== 0) {
			listRef.current.scrollToItem({ rowIndex: 0 });
		}
	}, [data]);

	useEffect(() => {
		if (focussedPartnerId && listRef.current) {
			const partnerRowIndex = data.partners.findIndex((item) => item.id === focussedPartnerId);
			listRef.current.scrollToItem(partnerRowIndex);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [focussedPartnerId]);

	if (!!width && !!height && isPartnerListDrawerVisible) {
		return (
			<Box height="100%" width="100%" display="flex" flexDirection="column" className={classes.root}>
				<List
					ref={listRef}
					className="List o-fhw-search__scrollbars"
					height={height}
					itemCount={data && data.count ? data.count : 1}
					itemSize={192}
					width={width}
					itemData={data ?? {}}>
					{Row}
				</List>
			</Box>
		);
	}

	return null;
};

export default memo(PartnerList);

const useStyles = makeStyles((theme) => ({
	root: {
		overflowX: 'hidden',
	},
	errorMessageSpan: {
		margin: '24px',
	},
}));
